let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aiceI")).then(() => parcelRequire('01szy'));